export const updateDate = (payload) => {
  return { type: "UPDATE_DATE", payload };
};
